import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f56187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-5" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Namn", -1))
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form-label"
}, "Beskrivning", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "price",
  class: "form-label"
}, "Pris", -1))
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "meta-description",
  class: "form-label"
}, "Meta-beskrivning", -1))
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "model",
  class: "form-label"
}, "Modell", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: ""
}, "Välj modell", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "category",
  class: "form-label"
}, "Kategori", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: ""
}, "Välj kategori", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form-check mb-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "is-sold"
}, " Såld ", -1))
const _hoisted_23 = { class: "form-check mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "is-active"
}, " Aktiv ", -1))
const _hoisted_25 = { class: "col-7" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "accent-4" }, "Specifikationer", -1))
const _hoisted_28 = { class: "list-group" }
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "attribute-value" }
const _hoisted_31 = ["id", "onUpdate:modelValue"]
const _hoisted_32 = { class: "attribute-description" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "col-12 mt-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "accent-4" }, "Lämpar sig för", -1))
const _hoisted_36 = ["onUpdate:modelValue", "id"]
const _hoisted_37 = ["for"]
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "image",
  class: "form-label"
}, "Bild(er)", -1))
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "image-container" }
const _hoisted_44 = ["href"]
const _hoisted_45 = ["src"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "SPARA", -1))

import { ref, onMounted } from 'vue';
    import Spinner from '@/components/Spinner.vue';
    import { categoryApi } from '@/services/category.service';
    import { attributeApi } from '@/services/attribute.service';
    import { modelApi } from '@/services/model.service';
    import { articleApi } from '@/services/article.service';
    import { suitableForApi } from '@/services/suitable-for.service';
    import { fileApi } from '@/services/file.service';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import { Model } from '@/types/Model';
    import { AttributeItem } from '@/types/AttributeItem';
    import { SaveArticle } from '@/types/SaveArticle';
    import { SuitsFor } from '@/types/SuitsFor';
    import { SaveSuitsFor } from '@/types/SaveSuitsFor';
    import { useRoute } from 'vue-router';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'SaveArticle',
  setup(__props) {

    const route = useRoute();

    const article = ref<SaveArticle>({
        id: -1,
        name: '',
        description: '',
        metaDescription: null,
        modelId: -1,
        categoryId: -1,
        attributes: [],
        files: [],
        suitsFor: [],
        isSold: false,
        isActive: true,
        price: 0
    });

    const isLoading = ref(true);

    const selectedCategoryId = ref(-1);
    const selectedModelId = ref(-1);
    const oldFiles = ref<File[]>([])
    const newFiles = ref<File[]>([]) 
    const fileInput = ref<HTMLInputElement | null>(null);

    const categories = ref<CategoryViewModel[]>([]);
    const models = ref<Model[]>([]);
    const attributes = ref<AttributeItem[]>([]);
    const suitsForList = ref<SaveSuitsFor[]>();

    const addArticle = async () => {
        isLoading.value = true;

        // Validera att både kategori och modell är valda
        if (selectedCategoryId.value < 0)
            return alert('Vänligen välj en kategori');

        // Skapa artikelobjektet
        const articleObj = {
            id: article.value.id,
            name: article.value.name,
            description: article.value.description,
            metaDescription: article.value.metaDescription,
            modelId: selectedModelId.value,
            categoryId: selectedCategoryId.value,
            suitsFor: getSuitsFor(),
            attributes: getAttributes(),
            files: article.value.files,
            isSold: article.value.isSold,
            isActive: article.value.isActive,
            price: article.value.price
        };

        const formData = new FormData();
        formData.append('article', JSON.stringify(articleObj));
        newFiles.value.forEach((file, index) => {
            formData.append('files', file);
        });

        await articleApi.add(formData);
        await fetchAll();
        isLoading.value = false;
    };

    const checkAspectRatio = (file: File): Promise<boolean> => {
        return new Promise((resolve) => {
            const image = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                image.src = e.target?.result as string;
            };
            reader.readAsDataURL(file);

            image.onload = () => {
                const width = image.width;
                const height = image.height;
                const aspectRatio = width / height;
                const targetAspectRatio = 4 / 3;

                if (Math.abs(aspectRatio - targetAspectRatio) > 0.01) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            };
        });
    };

    const handleImageUpload = async (event: Event) => {
        const fileList = (event.target as HTMLInputElement).files || [];
        const selectedImages = Array.from(fileList).filter((file) => file.type.startsWith('image/'));

        const invalidFiles: string[] = [];
        for (const file of selectedImages) {
            const isValid = await checkAspectRatio(file);
            if (!isValid) {
                invalidFiles.push(file.name);
            }
        }

        if (invalidFiles.length > 0) {
            alert(`Formatet måste vara i 4:3. Följande bilder uppfyller inte kraven ${invalidFiles.join(', ')}`);
        } else {
            newFiles.value = selectedImages;
        }
    };

    const removeImage = async (entityId: number, fileId: number) => {
        try {
            isLoading.value = true;
            await fileApi.remove(0, entityId, fileId);
            oldFiles.value = oldFiles.value.filter(file => file.id !== fileId);
        } catch (e) {
            alert(e);
        }
        isLoading.value = false;
    };

    const getAttributes = () => {
        const selectedAttributes = attributes.value
            .filter(x => x.value !== null);

        return selectedAttributes;
    };

    const getSuitsFor = () => {
        const selected = suitsForList.value?.filter(x => x.isChecked);
        return selected;
    };

    const fetchAll = async() => {
        categories.value = await categoryApi.getAll();
        models.value = await modelApi.getAll();
        attributes.value = await attributeApi.getAll();
        suitsForList.value = (await suitableForApi.getAll()) as SaveSuitsFor[];
        newFiles.value = [];
        if (fileInput.value)
            fileInput.value.value = '';

        const articleId = Number(route.params.id);
        if (articleId > 0) {
            article.value = await articleApi.fetchById(articleId);
            selectedCategoryId.value = article.value.categoryId;
            selectedModelId.value = article.value.modelId;

            attributes.value = article.value.attributes;
            suitsForList.value = article.value.suitsFor as SaveSuitsFor[];
            oldFiles.value = article.value.files;
        }

        isLoading.value = false;
    }

    onMounted(async () => {
        try {
            await fetchAll();

        } catch (error) {
            console.error('Fel vid hämtning av data från API:', error);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(article.value.id === -1 ? 'Lägg till ' : 'Ändra ') + "artikel", 1),
    _withDirectives(_createElementVNode("form", {
      onSubmit: _withModifiers(addArticle, ["prevent"]),
      class: "mt-4"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((article.value.name) = $event)),
              required: "",
              class: "form-control"
            }, null, 512), [
              [_vModelText, article.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((article.value.description) = $event)),
              class: "form-control"
            }, null, 512), [
              [_vModelText, article.value.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "price",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((article.value.price) = $event)),
              required: "",
              class: "form-control"
            }, null, 512), [
              [_vModelText, article.value.price]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("textarea", {
              id: "meta-description",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((article.value.metaDescription) = $event)),
              class: "form-control",
              maxlength: "280",
              placeholder: "Mycket beskrivande test för sökmotorer max: 270 tecken. Om Denna lämnas blank tas meta beskrivning från modell."
            }, null, 512), [
              [_vModelText, article.value.metaDescription]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              id: "model",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedModelId).value = $event)),
              required: "",
              class: "form-select"
            }, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, (model) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: model.id,
                  key: model.id
                }, _toDisplayString(model.name), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedModelId.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("select", {
              id: "category",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedCategoryId).value = $event)),
              required: "",
              class: "form-select"
            }, [
              _hoisted_19,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: category.id,
                  key: category.id
                }, _toDisplayString(category.name), 9, _hoisted_20))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedCategoryId.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((article.value.isSold) = $event)),
              type: "checkbox",
              value: "",
              id: "is-sold"
            }, null, 512), [
              [_vModelCheckbox, article.value.isSold]
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((article.value.isActive) = $event)),
              type: "checkbox",
              value: "",
              id: "is-active"
            }, null, 512), [
              [_vModelCheckbox, article.value.isActive]
            ]),
            _hoisted_24
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("ul", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attribute) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-group-item attribute-item",
                  key: attribute.id
                }, [
                  _createElementVNode("label", {
                    for: `label-for-${attribute.id}`,
                    class: "attribute-name"
                  }, _toDisplayString(attribute.name.toUpperCase()), 9, _hoisted_29),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: `label-for-${attribute.id}`,
                      class: "form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event)
                    }, null, 8, _hoisted_31), [
                      [_vModelText, attribute.value]
                    ]),
                    _createTextVNode(" " + _toDisplayString(attribute.unit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((attribute.description) = $event),
                      placeholder: "Ange beskrivning..."
                    }, null, 8, _hoisted_33), [
                      [_vModelText, attribute.description]
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suitsForList.value, (suit) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-check mb-3",
                key: suit.id
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  "onUpdate:modelValue": ($event: any) => ((suit.isChecked) = $event),
                  type: "checkbox",
                  id: `label-for-suit-${suit.id}`
                }, null, 8, _hoisted_36), [
                  [_vModelCheckbox, suit.isChecked]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `label-for-suit-${suit.id}`
                }, _toDisplayString(suit.name.toUpperCase()), 9, _hoisted_37)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oldFiles.value, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-4",
                  key: image.id
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("a", {
                      href: `/images/${image.name}.jpg`,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: `/images/${image.name}.webp`,
                        class: "img-fluid"
                      }, null, 8, _hoisted_45)
                    ], 8, _hoisted_44),
                    _createElementVNode("button", {
                      class: "btn btn-danger btn-sm",
                      onClick: _withModifiers(($event: any) => (removeImage(image.entityId, image.id)), ["prevent"])
                    }, " Ta bort ", 8, _hoisted_46)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("input", {
              type: "file",
              ref_key: "fileInput",
              ref: fileInput,
              id: "image",
              onChange: handleImageUpload,
              class: "form-control mt-3",
              multiple: ""
            }, null, 544)
          ]),
          _hoisted_47
        ])
      ])
    ], 40, _hoisted_2), [
      [_vShow, !isLoading.value]
    ]),
    _createVNode(Spinner, { spinn: isLoading.value }, null, 8, ["spinn"])
  ]))
}
}

})